import ComponentSwitcher from './ComponentSwitcher';

export default ComponentSwitcher;
